

































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppCheckRound from '@/components/AppCheckRound.vue'
import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import { Order, OrderDelivery } from '@/interfaces'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppCheckRound,
    AppTwoColsCard
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop() readonly order!: Order
  @Prop() readonly orderDelivery!: OrderDelivery
  @Prop() readonly returnFeeType!: string
  @Prop() readonly returnAllItems!: boolean
  @Prop() readonly returnFee!: number|null

  get estimiatedReturnFee () {
    if (this.returnFee !== null && this.returnFee >= 0) {
      return this.returnFee
    } else {
      return this.sellerDeliveryFee * (this.returnAllItems ? 2 : 1)
    }
  }

  get sellerDeliveryFee () {
    return (this.orderDelivery.seller ? this.orderDelivery.seller.shop.returnFee : 0) + this.orderDelivery.shopExtraDeliveryFee
  }

  get sellerBankAccountHolderName () {
    return this.orderDelivery.seller ? this.orderDelivery.seller.shop.accountHolderName : ''
  }

  get sellerBankAccount () {
    return this.orderDelivery.seller ? `${this.orderDelivery.seller.shop.bankName} ${this.orderDelivery.seller.shop.bankAccount}` : ''
  }

  get sellerAvailableFeeTypes () {
    return this.orderDelivery.seller ? this.orderDelivery.seller.shop.availableReturnFeeTypes : []
  }

  showAlert () {
    alert(`반품 비용은 반품 사유가 ‘구매자 귀책’일 경우 발생하는 비용으로, 경우에 따라 왕복 배송비 또는 반품 배송비가 청구될 수 있습니다. 

* 왕복 배송비 (반품 배송비 + 최초 배송비) 
* 반품 배송비 = 상품을 판매자에게 돌려 보낼 때 발생하는 택배비
* 최초 배송비 = 구매자가 상품을 받을 때 결제한 택배비`
    )
  }
}
